export class ErrorBase<T extends string> extends Error {
	code: T;
	msg: string;

	constructor({ code, msg }: { code: T; msg: string }) {
		super(code);
		this.code = code;
		this.msg = msg;

		Object.setPrototypeOf(this, new.target.prototype);
	}

	static isErrorBase(error: unknown): error is ErrorBase<string> {
		return (
			typeof error === 'object' &&
			error !== null &&
			'code' in error &&
			'msg' in error &&
			typeof error.code === 'string' &&
			typeof error.msg === 'string'
		);
	}
}
